import { Link } from 'react-router-dom'
import { ROUTES } from '../Routes'
import React from 'react'

const GameSection = () => {
    return (
        <section className="game-section" id="game">
            <div className="game-container">
                <span className="section-label">Featured Game</span>
                <h2 className="section-title"><span className="highlight">Jackpot</span> Slots</h2>
                <p style={{ color: '#a0aec0', maxWidth: '600px', margin: '0 auto' }}>
                    Step into Socialuk Slots, your gateway to thrilling entertainment where each spin brings excitement.
                    Experience the rush of the reels in a risk-free environment designed purely for fun!
                </p>
                <div className="game-preview">
                    <div className="game-preview-image">
                        <div className="slot-preview">
                            <div className="slot-reel">7</div>
                            <div className="slot-reel">7</div>
                            <div className="slot-reel">7</div>
                            <div className="slot-reel">$</div>
                            <div className="slot-reel">*</div>
                        </div>
                    </div>
                </div>
                <Link to={ROUTES.GAME} className="btn btn-primary" style={{ marginTop: '40px' }}>Play Now</Link>
            </div>
        </section>
    )
}

export default GameSection